import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { PoliticalPartySearchProvider } from './context/political-party-search-context';
import { PoliticalPartySearchComponent } from './political-party-search-component';

export function PoliticalPartySearchFactory() {
    return (
        <BaseLayoutFactory>
            <PoliticalPartySearchProvider>
                <PoliticalPartySearchComponent />
            </PoliticalPartySearchProvider>
        </BaseLayoutFactory>
    );
}
